
// 获取随机颜色
export function getRandomColor (): string {
  const ary = ['#2490F8', '#6245F8', '#F76B35', '#CB0000', '#B74DBE', '#7BB68A', '#F742AA', '#337AB7', '#59BBCC']
  const index = Math.floor(Math.random() * ary.length)
  return ary[index]
}

//找到最大的RGB
export function findMaxRGB(R, G, B) {
  let max
  let index
  if (R >= G && R >= B) {
    max = R
    index = 'R'
  }
  if (G >= R && G >= B) {
    max = G
    index = 'G'
  }
  if (B >= R && B >= G) {
    max = B
    index = 'B'
  }
  return {
    [index]: max
  }
}

export function getShallowRGB(maxColorObject, R, G, B,num:number) {
  let threshold = 22*(num+1)//色阶偏差值
  let offset = 10*(num)//色深偏差值
  let result = []
  for (var d in maxColorObject) {
    if (d == 'R') {
      result = [
        [R - offset, G + threshold, B + threshold],
        [R - offset, G + threshold+5, B + threshold+5],
        [R - offset, G + threshold+8, B + threshold+8]
      ]
    } else if (d == 'G') {
      result = [
        [R + threshold, G - offset, B + threshold],
        [R + threshold+5, G - offset, B + threshold+5],
        [R + 0, G - offset, B + 0]
      ]
    } else if (d == 'B') {
      result = [
        [R + threshold, G + threshold, B - offset],
        [R + threshold+10, G + threshold+10, B - offset],
        [R + threshold+0, G + threshold+0, B - offset]
      ]
    }
  }
  return result
}
//16进制转RGB
export function foramgeRGB(color) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  color = color.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (var i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
    }
    return colorChange.join(",");
  } else {
    return color;
  }
};
